// extracted by mini-css-extract-plugin
module.exports = {"companyGoalsContainer":"CompanyGoalsContainer_companyGoalsContainer__D4AQr","title":"CompanyGoalsContainer_title__2p8Tl","filterBar":"CompanyGoalsContainer_filterBar__ePhKO"};